import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// @material-ui/core components
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';

// material-ui icons
import Menu from '@material-ui/icons/Menu';

// core components
import { useLocation } from 'react-router-dom';
import Button from '../CustomButtons/Button';
import HeaderLinks from './HeaderLinks';

import { useHeaderStyle } from './headerStyle';

// TODO: Add tests
const getBrandTitle = (pathname, routes) => routes.reduce(
  (acc, { name, path, redirect }) => (!redirect && path.split('/')[1] === pathname.split('/')[1] ? name : acc),
  'Defaut Brand Name'
);

const Header = ({ color, handleDrawerToggle, routes }) => {
  const classes = useHeaderStyle();
  const location = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const brandTitle = useMemo(() => getBrandTitle(location.pathname, routes), [location.pathname]);

  const appBarClasses = cx({
    [` ${classes[color]}`]: color,
  });

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          <div className={classes.brand}>{brandTitle}</div>
        </div>
        <HeaderLinks />
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  color             : PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  handleDrawerToggle: PropTypes.func,
  routes            : PropTypes.arrayOf(PropTypes.shape({})),
};

Header.defaultProps = {
  color : undefined,
  handleDrawerToggle() {},
  routes: [],
};

export default Header;
